export const config = {
  baseUrl: process.env.VUE_APP_BASE_URL,
  YOUTUBE_API_KEY: process.env.VUE_APP_YOUTUBE_API_KEY,
  CAST_APP_ID: process.env.VUE_APP_CAST_APP_ID || '3B6A2555' // Default to production ID if not set
}
